import NewPurchaseContainer from './NewPurchaseContainer';

export default NewPurchaseContainer;
